import Loadable from '../loadable';

export default Loadable(() =>
  import(/* webpackChunkName: "app-rate" */ './index')
);
